document.addEventListener("DOMContentLoaded", function() {
  // Check if the element with id "discountCard" exists
  var discountCardElem = document.getElementById("discountCard");

  if (discountCardElem) {
    // Attach the click event listener only if the element exists
    discountCardElem.addEventListener("click", copyToClipboard);
  }

  function copyToClipboard() {
    // Get the discount code text
    var discountCode = document.getElementById("discountCode").innerText;

    // Create a temporary input element to copy the text
    var tempInput = document.createElement("input");
    tempInput.value = discountCode;
    document.body.appendChild(tempInput);

    // Select the text and copy it to clipboard
    tempInput.select();
    tempInput.setSelectionRange(0, 99999); // For mobile devices

    document.execCommand("copy");

    // Remove the temporary input element
    document.body.removeChild(tempInput);

    // Show the "Code copied!" message
    var message = document.getElementById("codeCopiedMessage");
    if (message) {
      message.classList.add("show");
      message.style.opacity = 1;
      
      // Hide the message after 3 seconds
      setTimeout(function() {
        message.style.opacity = 0;
        message.classList.remove("show");
      }, 2000); // 3 seconds
    }
  }
});